export const initialStateLoader = {
    status: false,
    message: '',
    hasError: false,
}

export const loaderReducer = (
    initialState = {}, 
    action = { type: '', payload: '' }
) => {
    switch (action.type) {
        case '[LOADER] Start':
            console.log('LOADER_START', action.payload);
            return {
                ...initialState,
                status: true,
                message: action.payload,
            }
        case '[LOADER] Error':
            return {
                ...initialState,
                message: action.payload,
                hasError: true,
            }
        case '[LOADER] Complete':
            return {
                ...initialState,
                status: false,
                message: '',
                hasError: false,
            }
        default:
            return initialState;
    }
}